import { createFileRoute } from "@tanstack/react-router";
import { StudiosAvailablePage } from "@/views/public/studios/StudiosAvailablePage.tsx";

export const Route = createFileRoute("/_public/studios/disponibles")({
  validateSearch: (search: Record<string, unknown>) => ({
    type: typeof search.type === "string" && search.type ? search.type : undefined,
  }),
  component: StudiosAvailablePage,
});
